import { render, staticRenderFns } from "./CompetitionCaseDetail.vue?vue&type=template&id=cdae7ada&scoped=true"
import script from "./CompetitionCaseDetail.vue?vue&type=script&lang=js"
export * from "./CompetitionCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCaseDetail.vue?vue&type=style&index=0&id=cdae7ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdae7ada",
  null
  
)

export default component.exports